module.exports = __webpack_public_path__ + "img/img26.7fbc9ffe.png";